// @ts-nocheck
import validator from "validator";
import { isValidPhone } from "../../../utils/validators";
import { normalizePhoneNumber } from "../../../utils";

export function createStudentFormValidator(values) {
  const errors: any = {};

  if (!values.name) {
    errors.name = "Name is required.";
  }
  if (!values.phone) {
    errors.phone = "Phone number is required.";
  } else if (!isValidPhone(normalizePhoneNumber(values.phone), null)) {
    errors.phone = "Invalid phone number.";
  }

  if (!values.email) {
    errors.email = "Email is required.";
  } else if (!validator.isEmail(values.email)) {
    errors.email = "Email must be a valid email address.";
  }

  if (!values.studentProfile) {
    errors.studentProfile = {
      birth_date: "Birth date is required.",
      country: "Country is required.",
      city: "City is required.",
      citizenship: "Citizenship is required.",
    };
  } else {
    errors.studentProfile = {};
    if (!values.studentProfile.birth_date) {
      errors.studentProfile.birth_date = "Birth date is required.";
    }
    if (!values.studentProfile.country) {
      errors.studentProfile.country = "Country is required.";
    }
    if (!values.studentProfile.city) {
      errors.studentProfile.city = "City is required";
    } else if (values.studentProfile.city.trim().length < 2) {
      errors.studentProfile.city = "City must have minimum 2 characters";
    }
    if (!values.studentProfile.citizenship) {
      errors.studentProfile.citizenship = "Citizenship is required.";
    }
  }

  return errors;
}
